// extracted by mini-css-extract-plugin
module.exports = {"mobile":"mobile-app-module__mobile___3CwR0"};